import type { GraphQLError } from 'graphql';

import { SYSTEM_HELP } from '@confluence/web-item-location/entry-points/webFragmentLocations.ts';
import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import type { WebItemLocationQueryType } from '@confluence/web-item-location/entry-points/WebItemLocationQuery.ts';

import HelpPanelQuery, {
	type HelpPanelQuery$data,
	type HelpPanelQuery$variables,
} from './__generated__/HelpPanelQuery.graphql.ts';

export const preloadHelpMenu = (): Promise<
	| void
	| Error[]
	| (
			| void
			| {
					data: WebItemLocationQueryType | null;
					errors?: ReadonlyArray<GraphQLError>;
					hasErrors: boolean;
			  }
			| {
					data: HelpPanelQuery$data | null;
					errors?: ReadonlyArray<GraphQLError>;
					hasErrors: boolean;
			  }
	  )[]
> => {
	return waitForAllReturnWhenError([
		preloadWebItemLocation({ location: SYSTEM_HELP }),
		query<HelpPanelQuery$data, HelpPanelQuery$variables>({ query: HelpPanelQuery }),
	]);
};
